export const baseURL = "https://pakbudi.s3-ap-southeast-1.amazonaws.com/images/";
export const baseUrl = "https://tes-minat-bakat-images.s3-ap-southeast-1.amazonaws.com/";
export const logo = `${baseUrl}pb-tmb-logo.png`